import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from "react-router-dom";
import EventDesc from './EventDesc';
import Footer from './Footer';

export function CompletePage(props) {

    let { eventCode } = useParams();
    const [noEvent, setNoEvent] = useState(false);
    const [eventDetail, setEventDetail] = useState({});

    useEffect(() => {
        var selectedEvent = props.eventDetails.find(d => Object.keys(d)[0] === eventCode);
        if (selectedEvent) {
            setEventDetail(selectedEvent[eventCode]);
        } else {
            setNoEvent(true);
        }
    }, [props.eventDetails, eventCode]);

    return (
        <div>
            <div className="text-center justify-content-center border-bottom padding-15">
                <div>
                    <h2>BALLOT REGISTRATION IS COMPLETED.</h2>
                    <h2>Please do not refresh the browser</h2>
                    <h2>閣下已完成登記，請避免重新更新頁面</h2>
                </div>
            </div>
            <div className="text-center justify-content-center padding-15">
                <div>
                    <h4>Your registration has been well received. Good luck!</h4>
                    <h4>我們已收到您的抽獎登記，祝您好運!</h4>
                </div>
            </div>
            <EventDesc {...eventDetail} hide={true} />
            <Footer />
            {
                noEvent && <Redirect to={'/'} />
            }
        </div>
    );
}
